import {Box} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import AuthForm from "auth/AuthForm";
import AuthInterceptorBridge from "auth/AuthInterceptorBridge";
import {ConfigsProvider} from "context/ConfigsContext";
import {ThemeModeProvider} from "context/ThemeProvider";
import {UnitsProvider} from "context/UnitsContext";
import {useAuth} from "hooks/useAuth";
import type {FC} from "react";
import {RouterProvider} from "react-router";
import {NotificationProvider} from "services/notification/NotificationProvider";
import {NotificationSystem} from "services/notification/NotificationSystem";
import {ToastBridge} from "services/notification/ToastBridge";
import router from "./router/router";

const App: FC = () => {
  const {user} = useAuth();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <NotificationProvider>
        <ThemeModeProvider>
          <ToastBridge />
          <AuthInterceptorBridge />

          {user === null && <AuthForm />}

          {user && (
            <UnitsProvider>
              <ConfigsProvider>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "100vh",
                  }}>
                  <Box sx={{flex: 1, overflowY: "auto"}}>
                    <RouterProvider router={router} />
                  </Box>
                </Box>
              </ConfigsProvider>
            </UnitsProvider>
          )}

          <NotificationSystem />
        </ThemeModeProvider>
      </NotificationProvider>
    </LocalizationProvider>
  );
};

export default App;
